module.exports = __webpack_public_path__ + "static/media/icon_more.4b008caf.svg";